import { useParams } from 'react-router-dom'
import { useProjectQuery } from 'hooks/useApiQuery'

export const useBreadcrumbsProjectData = () => {
  const { projectUrlName } = useParams()
  const { data: projectData } = useProjectQuery({ projectUrlName })

  return projectData
}
